import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getHasRetrievedSharedReportsSelector,
  getIsCreditReportUnavailableSelector,
} from '../../../../../../../selectors/sharedReports';
import { IcraaComplianceContext } from '../../../../../../../contexts/IcraaComplianceContext';
import { updateReportsLoadingStatuses } from '../../../../../../../actions/loadingStatusActionCreators';

function CreditReportNavigation({ applicantId, customNavigationCallback, setCustomNavigationCallback }) {
  const dispatch = useDispatch();
  const hasRetrievedSharedReports = useSelector(getHasRetrievedSharedReportsSelector(applicantId));
  const isCreditReportUnavailable = useSelector(getIsCreditReportUnavailableSelector(applicantId));
  const { icraaAcceptedForApplicant } = useContext(IcraaComplianceContext);

  useEffect(() => {
    if (customNavigationCallback) {
      if (hasRetrievedSharedReports && icraaAcceptedForApplicant) {
        dispatch(updateReportsLoadingStatuses({ creditReportLoading: false }));
        setCustomNavigationCallback(null);

        /**
         * Navigation to report if report is available. If not, an
         * error alert gets shown.
         */
        if (!isCreditReportUnavailable) {
          customNavigationCallback();
        }
      } else {
        // We're waiting for shared reports, so disable view button.
        dispatch(updateReportsLoadingStatuses({ creditReportLoading: true }));
      }
    }
  }, [
    customNavigationCallback,
    hasRetrievedSharedReports,
    isCreditReportUnavailable,
    setCustomNavigationCallback,
    icraaAcceptedForApplicant,
    dispatch,
  ]);

  return null;
}

CreditReportNavigation.propTypes = {
  applicantId: PropTypes.string.isRequired,
  customNavigationCallback: PropTypes.func,
  setCustomNavigationCallback: PropTypes.func.isRequired,
};

export default CreditReportNavigation;
